import { Component, ElementRef, ViewChild } from '@angular/core';
import { SocialmediaComponent } from "../socialmedia/socialmedia.component";
import { RouterModule } from '@angular/router';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-banner',
  imports: [SocialmediaComponent, RouterModule],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent {

  clickBurgerMenuElement: Subscription = new Subscription();

  @ViewChild('burgerMenu') burgerMenuElement!: ElementRef;
  @ViewChild('pageContainer') pageContainerElement!: ElementRef;
  
  ngOnInit(): void {
  }

  ngAfterViewInit() {

    this.clickBurgerMenuElement = fromEvent(this.burgerMenuElement.nativeElement, 'click').subscribe(() => 
      {
        this.burgerMenuElement.nativeElement.classList.toggle("close");
        this.pageContainerElement.nativeElement.classList.toggle("overlay");
      }
    );
  }

  ngOnDestroy() {

    // Performance reasons
    this.clickBurgerMenuElement.unsubscribe();
  }
}
